var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.309 17.428c1.76 0 3.385.801 4.458 2.197a5.585 5.585 0 0 1 .974 4.873L48.43 36.92a5.627 5.627 0 0 1-5.431 4.174h-25.17a5.628 5.628 0 0 1-5.431-4.173L6.125 13.4a.951.951 0 0 0-.917-.705h-2.43a1.894 1.894 0 0 1 0-3.786h2.43a4.74 4.74 0 0 1 4.576 3.515l1.333 5.004H46.31zm-24.68 18.349a1.893 1.893 0 0 0 1.87-2.195l-1.486-9.203a1.893 1.893 0 1 0-3.738.603l1.486 9.203c.152.93.954 1.592 1.868 1.592zm8.599-.364a1.894 1.894 0 0 0 1.893-1.893V25a1.894 1.894 0 0 0-3.787 0v8.52c0 1.045.849 1.893 1.894 1.893zm10.213-1.228 1.486-9.203a1.893 1.893 0 1 0-3.738-.603l-1.486 9.203a1.893 1.893 0 1 0 3.738.603zm-18.733 20.16a4.738 4.738 0 0 1-4.733-4.733 4.738 4.738 0 0 1 4.733-4.733 4.738 4.738 0 0 1 4.733 4.733 4.738 4.738 0 0 1-4.733 4.732zm17.038 0a4.738 4.738 0 0 1-4.733-4.733 4.738 4.738 0 0 1 4.733-4.733 4.738 4.738 0 0 1 4.733 4.733 4.738 4.738 0 0 1-4.733 4.732z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusket);
export default __webpack_public_path__ + "static/media/busket.67311a2580fa65dd0fe0243ec0ddd1ed.svg";
export { ForwardRef as ReactComponent };